export default {"src":"/_next/static/media/ez-ship-cart-icon.2aaeb960.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};